import { jsPDF } from "jspdf";
import { Hora } from "../Fecha";
import { firmaSubarrendatario, identificacionSubarrendatario, nombreParaArchivo } from "./ParteContratante";

export const Contrato30diasBodegaProvidencia = (datos, img) => {
	let { nombre, rut, fecha, correo, telefono } = datos;
	
	if (fecha === "hoy") {
		fecha = Hora();
	}
	const doc = new jsPDF();
	doc.setFont("arial");
	doc.setFontSize(20);
	doc.text("CONTRATO DE SUBARRIENDO DE BODEGA", 100, 25, { align: "center" });
	doc.line(20, 26, 183, 26);
	doc.setFontSize(12);
	doc.setLineHeightFactor(1.5);
	var text1 = `En Santiago de Chile, a ${fecha}, entre Asesorias e Inversiones DN SpA, Rut 77.526.796-8, representada legalmente por Rodrigo Andres Araya Montalvan, Rut 15.380.582-2, domiciliado en Av. Nueva Providencia 1945, oficina 807, Comuna de Providencia, como “SUB ARRENDADOR", y, don(a) ${identificacionSubarrendatario(datos)}, como el “SUB ARRENDATARIO” quienes han convenido celebrar el siguiente CONTRATO DE SUBARRENDAMIENTO DE BODEGA que se regirá por las cláusulas siguientes, y en silencio de ellas, por las disposiciones del Código Civil.`;
	var splitTitle1 = doc.splitTextToSize(text1, 190);
	doc.text(10, 40, splitTitle1);
	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("1° PROPIEDAD", 10, 92);
	doc.line(10, 93, 41, 93);
	doc.setFontSize(12);
	var text2 =
		"El SUB ARRENDADOR, se encuentra autorizado a sub arrendar la bodega Nº 54 del Cuarto Subterráneo ubicado en Av Nueva Providencia 1945, comuna de Providencia. Por el presente instrumento, el SUB ARRENDADOR, entrega en arriendo, en días y horas hábiles, la utilización de parte de la bodega (Lunes a Viernes de 9:00 a 18:00hrs).";
	var splitTitle2 = doc.splitTextToSize(text2, 190);
	doc.text(10, 101, splitTitle2);
	doc.setFont("arial", "normal");
	doc.setFontSize(12);
	doc.text("El presente Contrato de Subarriendo contempla los siguientes servicios:", 10, 133);
	doc.line(10, 134, 130, 134);
	var text6 =
		"1. Uso del rol de avalúo fiscal en propiedad con destino comercial y no habitacional.";
	var splitTitle6 = doc.splitTextToSize(text6, 160);
	doc.text(40, 143, splitTitle6);
	var text7 =
	    "2. Dirección tributaria para acreditar en el SII. Este contrato aplica únicamente para giros que el Servicio de Impuestos Internos permite de acuerdo con sus Circulares y Oficios. Es responsabilidad del cliente contar con los documentos requeridos por el SII que acrediten la actividad o actividades declaradas, o al menos garantizar que esto ocurra. La no obtención de autorización por parte del SII no dará derecho a devolución alguna.";
	var splitTitle7 = doc.splitTextToSize(text7, 160);
	doc.text(40, 151, splitTitle7);
	var text8 =
		"3. La recepción y almacenaje de cajas, paquetes o encomiendas se considera un servicio adicional con cobro de $5.000 + IVA por día completo o $3.000 + IVA por medio día.";
	var splitTitle8 = doc.splitTextToSize(text8, 160);
	doc.text(40, 184, splitTitle8);
	var text9 =
		"Sin perjuicio de lo anterior, queda expresamente prohibido al cliente utilizar el domicilio con otro propósito que no sea el descrito anteriormente. En consecuencia, el domicilio de la bodega NO podrá ser utilizado de ninguna manera para la obtención de créditos bancarios, financieros y/o comerciales, o de cualquier otra índole.";
	var splitTitle9 = doc.splitTextToSize(text9, 190);
	doc.text(10, 200, splitTitle9);
	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("2° RENTA", 10, 224);
	doc.line(10, 225, 30, 225);
	doc.setFont("arial", "normal");
	var text10 =
		"Las partes fijan la renta mensual de sub arriendo por la bodega en $11.990 (once mil novecientos noventa pesos). La que deberá ser pagada anticipadamente entre los días 1 y 5 de cada mes en la recepción ubicada en el interior de la oficina ubicada en Ahumada 254, oficina 806, Comuna de Santiago Centro, mediante transferencia bancaria o dinero efectivo.";
	var splitTitle10 = doc.splitTextToSize(text10, 190);
	doc.text(10, 235, splitTitle10);

	doc.addPage();
	doc.setFontSize(12);
	doc.setFont("arial", "normal");
	doc.text(
		"Si el pago se realiza via transferencia o depósito, deberán ser realizados a la siguiente cuenta:",
		10,
		20
	);
	doc.text("BANCO: BANCO ESTADO", 40, 28);
	doc.text("Nombre Empresa: ASESORIAS E INVERSIONES DN SpA", 40, 34);
	doc.text("Rut: 77.526.796-8", 40, 41);
	doc.text("Tipo de Cuenta: Chequera electrónica // cuenta vista", 40, 47);
	doc.text("Número de cuenta: 90270930912", 40, 53);
	doc.text("Correo: pagos@denegocios.cl", 40, 59);
	var text1 =
		"La renta se reajustará según el IPC (Índice de precios del consumidor) acumulado del año, al momento en que se tenga que renovar el contrato.";
	var splitTitle1 = doc.splitTextToSize(text1, 190);
	doc.text(10, 68, splitTitle1);
	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("3° PLAZO", 10, 85);
	doc.line(10, 86, 30, 86);
	doc.setFont("arial", "normal");
	var text2 = `El presente contrato empezó a regir el día ${fecha} y durará 2 meses de corrido. No obstante lo anteriormente señalado, este contrato se renovará sucesiva y automáticamente en períodos iguales al contratado, si ninguna de las partes da aviso a la otra con a lo menos 15 días de anticipación a la fecha de su vencimiento, por medio escrito, su deseo de poner término al presente contrato, e informando término de giro o cambio de domicilio ante Servicio de Impuestos Internos.`;
	var splitTitle2 = doc.splitTextToSize(text2, 190);
	doc.text(10, 95, splitTitle2);
	doc.setFont("arial", "bold");
	var text3 =
		"El Cliente puede rescindir contrato antes de lo anteriormente estipulado, es decir el cliente podrá dejar el contrato de arriendo antes del plazo de 2 meses. Para ello deberá dar aviso a través de correo a contacto@denegocios.cl y/o a soporte@denegocios.cl de que ya no utilizará nuestro domicilio y seguir las indicaciones que se le entregarán en dicho momento.";
	var splitTitle3 = doc.splitTextToSize(text3, 190);
	doc.text(10, 131, splitTitle3);
	doc.setFont("arial", "normal");
	var text3b =
		"Se deja constancia que este contrato si bien entra en rigor en la fecha indicada, el pago correspondiente comenzará a partir de los 30 días desde la fecha de firma. Es decir, el cliente tendrá 30 días desde la fecha de firma y de corrido, libres de todo pago.";
	var splitTitle3b = doc.splitTextToSize(text3b, 190);
	doc.text(10, 159, splitTitle3b);
	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("4° MULTAS, GASTOS Y COSTAS", 10, 180);
	doc.line(10, 181, 75, 181);
	doc.setFont("arial", "normal");
	var text4 =
		"Se conviene expresamente que por el no pago oportuno de la renta convenida, el SUB ARRENDATARIO, pagará una multa igual al interés máximo convencional para operaciones reajustables, multa que regirá desde el día siguiente del plazo que tienen para hacerlo y hasta la fecha que se realice el pago efectivo de la obligación.";
	var splitTitle4 = doc.splitTextToSize(text4, 190);
	doc.text(10, 187, splitTitle4);
	var text5 =
		"En caso de mensualidades con 30 días de atraso, se aplicará gasto de cobranza a partir del día 31 de mora, como porcentaje de la mensualidad adeudada.";
	var splitTitle5 = doc.splitTextToSize(text5, 190);
	doc.text(10, 206, splitTitle5);
	var text6 =
		"En caso de incumplimiento en el pago de las rentas convenidas, el SUB ARRENDADOR queda expresamente facultado para informar los datos del SUB ARRENDATARIO y de su representante legal al Boletín Comercial u otros sistemas de información comercial, previa notificación por escrito enviada al domicilio físico o correo electrónico registrado en este contrato. El SUB ARRENDATARIO tendrá un plazo de 5 días hábiles, contados desde la fecha de recepción de la notificación, para subsanar la deuda pendiente.";
	var splitTitle6 = doc.splitTextToSize(text6, 190);
	doc.text(10, 221, splitTitle6);
	var text7 =
		"El SUB ARRENDATARIO y su representante legal aceptan y consienten expresamente que, en caso de mora o simple retardo en el cumplimiento de sus obligaciones contractuales, sus datos personales sean tratados, utilizados y reportados a sistemas de información comercial de acuerdo con lo establecido en la Ley N° 19.628 sobre Protección de la Vida Privada, garantizándose sus derechos de acceso, rectificación, cancelación y oposición conforme a la normativa vigente.";
	var splitTitle7 = doc.splitTextToSize(text7, 190);
	doc.text(10, 255, splitTitle7);

	doc.addPage();
	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.setLineHeightFactor(1.1);
	doc.text("5° TERMINACIÓN ANTICIPADA DEL CONTRATO", 10, 20);
	doc.line(10, 21, 110, 21);
	doc.setFont("arial", "normal");
	var text8 =
		"EL SUB ARRENDADOR, podrá poner término de inmediato al presente contrato, por las siguientes causales que las partes convienen en elevar a la calidad de esenciales o determinantes en este contrato:";
	var splitTitle8 = doc.splitTextToSize(text8, 190);
	doc.text(10, 28, splitTitle8);
	doc.setFont("arial", "bold");
	doc.text(
		"1. Si destina la bodega a cualquier otro fin que no sea el indicado en este instrumento.",
		25,
		38
	);
	doc.text(
		"2. Si cede, subarrienda o transfiere a cualquier título el presente contrato.",
		25,
		44
	);
	doc.text(
		"3. Si contrae compromisos económicos o legales que afecten los intereses del SUBARRENDADOR.",
		25,
		50
	);
	doc.text(
		"4. Si causa inconvenientes a los vecinos, malos tratos con otros clientes o el personal de la bodega.",
		25,
		56
	);
	doc.text(
		"5. Si hace mal uso de las instalaciones como de los servicios ofrecidos por el SUBARRENDADOR.",
		25,
		62
	);
	doc.text(
		"6. Si no cancela dentro de los plazos el monto del arriendo.",
		25,
		68
	);

	doc.setFont("arial");
	doc.setFontSize(10);
	doc.text("Firmar esta Hoja", 7, 7);
	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("6° DOMICILIO", 10, 78);
	doc.line(10, 79, 40, 79);
	doc.setFont("arial", "normal");
	doc.text(
		"Para todos los efectos derivados del presente contrato, las partes fijan domicilio en la ciudad de Santiago.",
		10,
		84
	);
	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("7° EJEMPLARES DEL CONTRATO", 10, 92);
		doc.line(10, 93, 80, 93);
	doc.setFont("arial", "normal");
	var text1 =
		"El presente contrato se otorga en 2 (dos) ejemplares del mismo tenor, quedando 1 (uno) en poder del SUBARRENDADOR, y 1 (uno) en poder del SUBARRENDATARIO.";
	var splitTitle1 = doc.splitTextToSize(text1, 190);
	doc.text(10, 99, splitTitle1);
	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("8° RESPONSABILIDAD", 10, 112);
	doc.line(10, 113, 55, 113);
	doc.setFont("arial", "normal");
	var text2 =
		"Asesorias e Inversiones DN SpA no se hará cargo por multas e intereses ocasionados por falta de patente o vencimiento de ésta en el domicilio contratado.";
	var splitTitle2 = doc.splitTextToSize(text2, 190);
	doc.text(10, 119, splitTitle2);

	doc.setFont("arial", "bold");
	doc.setFontSize(12);
	doc.text("9° DATOS DE CONTACTO", 10, 132);
	doc.line(10, 133, 70, 133);
	doc.setFont("arial", "normal");
	var text3 = `Se deja en constancia que los datos de contacto del SUB ARRENDATARIO son los siguientes: Correo: ${correo}, Teléfono: ${telefono}.`;
	var splitTitle3 = doc.splitTextToSize(text3, 190);
	doc.text(10, 139, splitTitle3);

	doc.line(10, 170, 90, 170);
	doc.text("Asesorias e Inversiones DN SpA", 10, 175);
	doc.text("77.526.796-8", 10, 180);
	doc.text("P.p Rodrigo Andres Araya Montalvan", 10, 185);
	doc.text("15.380.582-2", 10, 190);
	firmaSubarrendatario(doc, datos, 219);

	doc.addPage();
	doc.setFont("arial");
	doc.setFontSize(10);
	doc.text("Firmar esta Hoja", 10, 10);
	doc.addImage(img, "JPEG", 30, 40, 140, 160);
	doc.setFontSize(12);
	var text4 = `Yo, ${nombre} C.I. nro. ${rut}, autorizo al Sr. Notario don JUAN RICARDO SAN MARTIN URREJOLA, para que autorice mi firma en el Contrato de SubArriendo, celebrado con fecha de hoy ${fecha}.`;
	var splitTitle4 = doc.splitTextToSize(text4, 190);
	doc.text(10, 220, splitTitle4);
	doc.line(65, 244, 135, 244);
	doc.text("Firma", 100, 250, { align: "center" });

	doc.save(`Contrato Arriendo Bodega Provisorio para ${nombreParaArchivo(datos)} en Providencia.pdf`);
};
